// Generated by Melange

import * as Caml_option from "melange.js/caml_option.js";
import * as Lui_elements from "lui/lui_elements.js";
import * as Mapre_web__Web_tool_call from "./web_tool_call.js";
import * as Signal from "ocaml-signal/signal.js";
import * as Stdlib__Option from "melange/option.js";

function detail(source, label, get) {
  const partial_arg = label;
  const partial_arg$1 = "eyebrow";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___001_) {
        const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map((function (call) {
          return Stdlib__Option.value(Stdlib__Option.bind(call, get), "");
        }), source)));
        const partial_arg$1 = "event-text tool-data";
        return function (param, param$1) {
          return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$2 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$3 = 0;
  const partial_arg$4 = 4;
  const partial_arg$5 = function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, param, param$1);
  };
  const partial_arg$6 = Signal.map((function (call) {
    return Stdlib__Option.bind(call, get) !== undefined;
  }), source);
  return function (param, param$1) {
    return Lui_elements.if_(partial_arg$6, partial_arg$5, param, param$1);
  };
}

function view(source) {
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___002_) {
      const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___002_.ui_scope, Signal.map((function (param) {
        return Stdlib__Option.fold("Tool call", Mapre_web__Web_tool_call.title, param);
      }), source)));
      const partial_arg$1 = "tool-title";
      return function (param, param$1) {
        return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___003_) {
        const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___003_.ui_scope, Signal.map((function (param) {
          return Stdlib__Option.fold("", Mapre_web__Web_tool_call.status_text, param);
        }), source)));
        const partial_arg$1 = "muted";
        return function (param, param$1) {
          return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$1 = "wrap";
  const partial_arg$2 = "space_between";
  const partial_arg$3 = 8;
  const partial_arg_0$1 = function (param, param$1) {
    return Lui_elements.row(undefined, partial_arg$3, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, partial_arg, param, param$1);
  };
  const partial_arg_1$1 = {
    hd: detail(source, "Arguments", (function (call) {
      return call.input;
    })),
    tl: {
      hd: detail(source, "Result", (function (call) {
        return call.output;
      })),
      tl: /* [] */ 0
    }
  };
  const partial_arg$4 = {
    hd: partial_arg_0$1,
    tl: partial_arg_1$1
  };
  const partial_arg$5 = 0;
  const partial_arg$6 = 10;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, param, param$1);
  };
}

export {
  view,
}
/* Lui_elements Not a pure module */
